import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchSentence, createSentence, updateSentence } from '../../actions/sentence';
import {  NavigationHeader, BrandSentencesContainer } from '../../components';

import './brandSentence.css';

class BrandSentences extends Component {
  constructor(props) {
    super(props);
    this.brandId = this.props.match.params.id;
  }

  // calls API to receive currently saved contact details for brand
  componentWillMount() {
    this.props.fetchSentence(this.brandId);
  }

  // when component receives props with data from API, will set details to be managed in state
  componentWillReceiveProps(nextProps) {
    if (nextProps.sentences !== this.props.sentences) {
      this.setState({
        isLoading: nextProps.sentences.isLoading,
        sentences: nextProps.sentences.sentences,
      })
    }
  }

  render () {
    return (
      <div className='form-container'>
        <NavigationHeader 
          id={this.brandId} 
          brand={this.props.brand}
          page='sentences'
        />
        <BrandSentencesContainer
          brandId={this.brandId}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.isLoading,
    isErroring: state.isErroring,
    sentences: state.sentence,
    brand: state.brandInfo,
  };
}

export default connect(mapStateToProps, { updateSentence, fetchSentence, createSentence })(BrandSentences);



// WEBPACK FOOTER //
// ./src/pages/brandSentences/BrandSentences.js